var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "customFieldCheck" },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
          _c("b-col", { attrs: { md: "12" } }, [
            _c("h6", [_vm._v("Custom Fields")]),
          ]),
        ],
        1
      ),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var handleSubmit = ref.handleSubmit
              var invalid = ref.invalid
              return [
                _c(
                  "div",
                  {
                    staticClass: "repeater-form",
                    style: { height: _vm.trHeight },
                  },
                  [
                    _vm._l(_vm.AdditionalFields, function (item, index) {
                      return _c(
                        "b-row",
                        {
                          key: item.ordering,
                          ref: "additionalFields",
                          refInFor: true,
                          attrs: { id: item.ordering },
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Field Name",
                                    "label-for": "fieldname",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Field Name",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "fieldname",
                                                  type: "text",
                                                  placeholder: "Field Name",
                                                  required: "",
                                                },
                                                model: {
                                                  value: item.fieldName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "fieldName",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.fieldName",
                                                },
                                              }),
                                              errors.length
                                                ? _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger text-end",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-50",
                              attrs: { lg: "3", md: "4" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(234, 84, 85, 0.15)",
                                      expression: "'rgba(234, 84, 85, 0.15)'",
                                      modifiers: { 400: true },
                                    },
                                  ],
                                  staticClass: "mt-0 mt-md-2",
                                  attrs: { variant: "outline-danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeItem(index)
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-25",
                                    attrs: { icon: "XIcon" },
                                  }),
                                  _c("span", [_vm._v("Delete")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    _c(
                      "b-row",
                      { staticClass: "justify-between-end" },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "3" } },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { 400: true },
                                  },
                                ],
                                attrs: { variant: "primary" },
                                on: { click: _vm.repeateAgain },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-25",
                                  attrs: { icon: "PlusIcon" },
                                }),
                                _c("span", [_vm._v("Add New")]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { cols: "3" } },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { 400: true },
                                  },
                                ],
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.upsertCustomFields)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("Save")])]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }